import type { GlobalStateCommandFactory } from 'components/GlobalState/GlobalStateModel';
import type { PermissionScope } from 'utils/hooks/usePermissionScope';

export interface AuthResponseData {
  id: string;
  scope: PermissionScope[];
}

export const saveAuth: GlobalStateCommandFactory<AuthResponseData> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      draft.auth.id = command.id;
      draft.auth.scope = command.scope;
    });
  };
